import React from 'react';
import { Layout, Menu, Typography } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  DatabaseOutlined,
  UserOutlined,
  SafetyCertificateOutlined,
  KeyOutlined,
  BankOutlined,
  NumberOutlined,
  CheckCircleOutlined,
  MailOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';

const { Sider, Content } = Layout;
const { Title } = Typography;

export const SettingsLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedKey = location.pathname.split('/').pop() || 'system';

  const menuItems: MenuProps['items'] = [
    {
      key: 'general',
      label: 'General',
      type: 'group',
      children: [
        { key: 'system', icon: <DatabaseOutlined />, label: 'System Settings' },
        { key: 'company', icon: <BankOutlined />, label: 'Company Profile' },
        { key: 'preferences', icon: <UserSwitchOutlined />, label: 'User Preferences' },
      ],
    },
    {
      key: 'security',
      label: 'Security & Access Control',
      type: 'group',
      children: [
        { key: 'users', icon: <UserOutlined />, label: 'Users' },
        { key: 'roles', icon: <SafetyCertificateOutlined />, label: 'Roles' },
        { key: 'permissions', icon: <KeyOutlined />, label: 'Permissions' },
      ],
    },
    {
      key: 'operations',
      label: 'Operations',
      type: 'group',
      children: [
        { key: 'sequences', icon: <NumberOutlined />, label: 'Document Sequences' },
      ],
    },
    {
      key: 'workflows',
      label: 'Workflows & Automation',
      type: 'group',
      children: [
        { key: 'approvals', icon: <CheckCircleOutlined />, label: 'Approval Workflows' },
        { key: 'templates', icon: <MailOutlined />, label: 'Email Templates' },
      ],
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>⚙️ Settings</Title>

      <Layout style={{ background: 'transparent', marginTop: '24px' }}>
        <Sider width={250} style={{ background: 'white', borderRadius: '8px' }}>
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            items={menuItems}
            onClick={({ key }) => navigate(`/settings/${key}`)}
          />
        </Sider>

        <Content style={{ marginLeft: '24px' }}>
          <Outlet />
        </Content>
      </Layout>
    </div>
  );
};

